import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SortableTableHeadCell from 'components/common/SortableTableHeadCell';

import ClaimsTableEmpty from './ClaimsTableEmpty';
import ClaimsTableRow from './ClaimsTableRow';

const styles = theme => ({
  paper: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 208px)',
    overflowX: 'auto',
    overflowY: 'visible',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 142px)',
      transition: theme.transitions.create(['height'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  paperMobileFilterExpanded: {
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 273px)',
    },
  },
  typography: {
    paddingLeft: 10,
    paddingBottom: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  table: {
    minWidth: 500,
  },
  tableHead: {
    position: 'sticky',
    zIndex: 20,
    top: 0,
    '& th:first-child': {
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
    '& th': {
      position: 'relative',
      zIndex: 1,
    },
  },
  hiddenCell: {
    fontSize: 0,
  },
  cellCount: {
    paddingRight: 0,
  },
  cellOrderNumber: {
    paddingLeft: 8,
  },
});
const СlaimsTable = ({
  items,
  count,
  onRowClick,
  classes,
  sort,
  sortBy,
  onSortingChange,
  business,
  loading,
  mobileFilterExpanded,
  onScroll,
  scrollRef,
  style,
}) => (
  <div>
    <Typography className={classes.typography}>
      Claims
      {(loading === 0 || items.length > 0) && (
        ` (${count})`
      )}
    </Typography>
    <RootRef rootRef={scrollRef}>
      <Paper
        className={classNames(classes.paper, {
          [classes.paperMobileFilterExpanded]: mobileFilterExpanded,
        })}
        style={style}
        onScroll={onScroll}
      >
      {(loading === 0 && items.length === 0) &&
        <ClaimsTableEmpty />
      }
      {items.length > 0 &&
        <Table className={classes.table}>
        <TableHead
          className={classes.tableHead}
        >
          <TableRow>
            <TableCell className={classes.cellCount}>
              Lines
            </TableCell>
            <TableCell className={classes.cellOrderNumber}>Order #</TableCell>
            <TableCell className={classes.cellSubmitDate}>
              <SortableTableHeadCell
                label="Submitted"
                sortField="Create At"
                tooltipLabel="Date of Creation"
                sortBy={sortBy}
                sort={sort}
                onSortingChange={onSortingChange}
                loading={loading}
              />
            </TableCell>
            <TableCell>Claim Status</TableCell>
            <TableCell>
              Patient
            </TableCell>
            <TableCell>Insurance</TableCell>
            <TableCell>
              <SortableTableHeadCell
                label="Date Of Service"
                sortField="Date of Service From"
                tooltipLabel="Date Of Service"
                sortBy={sortBy}
                sort={sort}
                onSortingChange={onSortingChange}
                loading={loading}
              />
            </TableCell>
            <TableCell>Charge</TableCell>
            <TableCell>Amount Paid</TableCell>
            <TableCell>Claim #</TableCell>
            <TableCell>Check Number</TableCell>
            <TableCell>Paid Date</TableCell>
            <TableCell>User</TableCell>
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(item => (
            <ClaimsTableRow
              key={item.ID}
              claim={item}
              business={business}
              {...onRowClick ? {
                hover: true,
                menu: false,
                onClick: () => { onRowClick(item); },
              } : {}}
            />
          ))}
        </TableBody>
        </Table>
      }
      </Paper>
    </RootRef>
  </div>
);

СlaimsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  count: PropTypes.number.isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }).isRequired,
  onRowClick: PropTypes.func,
  sort: PropTypes.oneOf(['asc', 'desc']),
  sortBy: PropTypes.string,
  onSortingChange: PropTypes.func,
  loading: PropTypes.number,
  style: PropTypes.shape({
    height: PropTypes.string,
  }),
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    hiddenCell: PropTypes.string.isRequired,
  }).isRequired,
};

СlaimsTable.defaultProps = {
  onRowClick: null,
  sort: null,
  sortBy: null,
  onSortingChange: null,
  loading: 0,
  business: {},
  style: null,
};

export default withStyles(styles)(СlaimsTable);



// WEBPACK FOOTER //
// ./src/components/reports/ClaimsTable/ClaimsTable.js